import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';
import { LoyaltyStatus, LOYALTY_STATUS, LoggingService } from '@fgb/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LockedRewardStatusComponent } from './statuses/locked-reward-status/locked-reward-status.component';
import { REWARD_STATUS_COMPONENTS } from './reward-status';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateRangeStatus } from './statuses/date-range';

@Component({
  selector: 'fgbcl-reward-status',
  standalone: true,
  imports: [CommonModule, FGBSharedModule, CountdownV2Component, LockedRewardStatusComponent],
  templateUrl: './reward-status.component.html',
  styleUrl: './reward-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RewardStatusComponent implements OnInit {
  @Input({ required: true }) status: LoyaltyStatus;
  @Input() startDate: any;
  @Input() comingSoonDate: any;
  @Output() itemStart: EventEmitter<any> = new EventEmitter();
  statusType = LOYALTY_STATUS;
  container = viewChild('statusContainer', { read: ViewContainerRef });

  private _statusComponents = inject(REWARD_STATUS_COMPONENTS);
  private logService = inject(LoggingService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.injectStatus();
  }

  private injectStatus() {
    let componentToCreate = this._statusComponents[this.status.status];
    if (componentToCreate == undefined) {
      this.logService.debug('unable to find component for status ' + this.status.status);
      return;
    }

    let statusComponent = this.container()?.createComponent(componentToCreate);

    if (statusComponent?.instance instanceof DateRangeStatus) {
      statusComponent?.setInput('startDate', this.startDate);
      statusComponent?.setInput('comingSoonDate', this.comingSoonDate);

      statusComponent?.instance?.itemStart.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.itemStart.emit();
      });
    }
  }
}
